export default __webpack_public_path__ + "dist/media/SignUp.43213f8b.svg";